import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Grid, Typography } from '@mui/material';

import { ConfirmDialogWithCheckbox } from 'app/components/ConfirmDialogWithCheckbox';
import { RegulationsFieldDisplay } from '../Fields';
import type { RegulationsField } from '../Fields';
import { IntlMessage } from 'app/components/Intl';
import { TranslationKeys } from 'app/translations';

type RegulationsRevertConfirmDialogProps = {
  open: boolean;
  label?: string;
  currentValue: any;
  defaultValue: any;
  fieldType?: RegulationsField['type'];
  fieldOptions?: RegulationsField['options'];
  onClose: () => void;
  onConfirm: () => void;
};

export const RegulationsRevertConfirmDialog = ({
  open,
  label,
  currentValue,
  defaultValue,
  fieldType,
  fieldOptions,
  onClose,
  onConfirm,
}: RegulationsRevertConfirmDialogProps) => {
  return (
    <ConfirmDialogWithCheckbox
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={<FormattedMessage id={TranslationKeys.regulations_revertConfirmation_title} />}
      checkboxLabel={<FormattedMessage id={TranslationKeys.regulations_revertConfirmation_checkboxLabel} />}
      testId={'regulations-revert-confirm-dialog'}
    >
      {label && (
        <Typography variant={'subtitle2'} gutterBottom>
          <IntlMessage value={label} />
        </Typography>
      )}
      <Typography variant={'body1'} gutterBottom>
        <FormattedMessage id={TranslationKeys.regulations_revertConfirmation_description} />
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography variant={'overline'}>
            <FormattedMessage id={TranslationKeys.regulations_revertConfirmation_currentValue} />
          </Typography>
          <Typography variant={'body1'}>
            <RegulationsFieldDisplay
              field={{ name: 'currentValue', type: fieldType, options: fieldOptions, value: currentValue }}
            />
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant={'overline'}>
            <FormattedMessage id={TranslationKeys.regulations_revertConfirmation_defaultValue} />
          </Typography>
          <Typography variant={'body1'}>
            <RegulationsFieldDisplay
              field={{ name: 'defaultValue', type: fieldType, options: fieldOptions, value: defaultValue }}
            />
          </Typography>
        </Grid>
      </Grid>
    </ConfirmDialogWithCheckbox>
  );
};
